import {
  createContext,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
  ReactElement,
  ReactNode,
} from 'react';

interface ContextProps {
  isOpenCart: boolean;
  setIsOpenCart: Dispatch<SetStateAction<boolean>>;
  isOpenMenu: boolean;
  setIsOpenMenu: Dispatch<SetStateAction<boolean>>;
}

interface ContextProviderProps {
  children?: ReactNode;
}

export const DrawerContext = createContext<ContextProps>({} as ContextProps);

export const DrawerContextProvider = ({
  children,
}: ContextProviderProps): ReactElement => {
  const [isOpenCart, setIsOpenCart] = useState<boolean>(false);
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);

  const values = {
    isOpenCart,
    setIsOpenCart,
    isOpenMenu,
    setIsOpenMenu,
  };

  return (
    <DrawerContext.Provider value={values}>{children}</DrawerContext.Provider>
  );
};

export const useDrawerContext = (): ContextProps => useContext(DrawerContext);
